import blockSpec from '@/lib/spec.js';

export default {
	async updateTextBlock(store, block) {
		let oldBlock = store.getters['block'](block._id);
		store.dispatch('updateBlock', block);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/updateBlock',
					payload: block
				}
			],
			{ root: true }
		);

		// Not adding this to the updatequeue cuz prosemirror handles ctrl+z stuff anyways
		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/updateBlock',
					payload: oldBlock
				}
			],
			{ root: true }
		);
	},

	async addTextBlocks(store, blocks) {
		let user = store.rootGetters['user/user'];
		let parent = store.rootGetters['dashboard/currentBlock'];
		let oldParent = JSON.parse(JSON.stringify(parent));
		blocks = blocks.map(block => {
			block.parent = block.parent || parent._id;
			block = blockSpec.createBlock(block, user._id);
			parent.blocks.push(block._id);
			return block;
		});

		store.dispatch('bulkAddBlocks', blocks);
		store.dispatch('updateBlock', parent);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/bulkAddBlocks',
					payload: blocks
				},
				{
					name: 'block/updateBlock',
					payload: parent
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/bulkAddBlocks',
					payload: blocks
				},
				{
					name: 'block/updateBlock',
					payload: oldParent
				}
			],
			{ root: true }
		);
	},

	/**
	 * Similar to addtextblocks except they take an additional blockid to determine block insertion position
	 */
	async addPastedTextBlocks(store, data) {
		let blocks = data.blocks;
		let insertBlockId = data.insertBlockId;
		let user = store.rootGetters['user/user'];
		let parent = store.rootGetters['dashboard/currentBlock'];
		let oldParent = JSON.parse(JSON.stringify(parent));
		console.log(parent.blocks);
		console.log(insertBlockId);
		// There's a bug here where position is -1 on a newly created text block
		let position = parent.blocks.indexOf(insertBlockId);

		if (position === -1) {
			position = 0;
		}

		blocks = blocks.map(block => {
			block.parent = block.parent || parent._id;
			block = blockSpec.createBlock(block, user._id);
			parent.blocks.splice(position, 0, block._id);
			position += 1;
			return block;
		});

		store.dispatch('bulkAddBlocks', blocks);
		store.dispatch('updateBlock', parent);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/bulkAddBlocks',
					payload: blocks
				},
				{
					name: 'block/updateBlock',
					payload: parent
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/bulkAddBlocks',
					payload: blocks
				},
				{
					name: 'block/updateBlock',
					payload: oldParent
				}
			],
			{ root: true }
		);
	},

	setPreviousTextBlockFocus: (store, blockId) => {
		let block = store.getters['block'](blockId);
		let parentBlock = store.getters['parentBlock'](block.parent);
		let blocksArray = parentBlock.blocks;
		let i = blocksArray.indexOf(blockId);
		if (blocksArray[i - 1]) {
			store.dispatch('dashboard/setFocus', blocksArray[i - 1], { root: true });
		}
	},

	setNextTextBlockFocus: (store, blockId) => {
		let block = store.getters['block'](blockId);
		let parentBlock = store.getters['parentBlock'](block.parent);
		let blocksArray = parentBlock.blocks;
		let i = blocksArray.indexOf(blockId);
		if (blocksArray[i + 1]) {
			store.dispatch('dashboard/setFocus', blocksArray[i + 1], { root: true });
		}
	},

	async removeTextBlock(store, blockId) {
		let block = store.getters['block'](blockId);
		let parentBlock = store.getters['parentBlock'](block.parent);

		let oldParentBlock = JSON.parse(JSON.stringify(parentBlock));
		// dont remove if current text block is the only one inside it
		if (parentBlock.blocks.length < 2) {
			return;
		}

		let data = {
			blocksArray: [block._id],
			parentBlock: parentBlock
		};

		let position = 0;
		let blocksArray = parentBlock.blocks;
		let previousBlockId = null;
		let nextBlockId = null;

		for (let i = 0; i < blocksArray.length; i++) {
			if (blocksArray[i] === block._id) {
				position = i;
				previousBlockId = blocksArray[i - 1];
				nextBlockId = blocksArray[i + 1];
				blocksArray.splice(i, 1);
				break;
			}
		}

		parentBlock.blocks = blocksArray;

		//await store.dispatch('removeBlocks', data);

		store.dispatch('updateBlock', parentBlock);

		store.dispatch('deleteBlock', block);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/updateBlock',
					payload: parentBlock
				},
				{
					name: 'block/deleteBlock',
					payload: block
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/updateBlock',
					payload: oldParentBlock
				},
				{
					name: 'block/deleteBlock',
					payload: block
				}
			],
			{ root: true }
		);

		if (previousBlockId) {
			store.dispatch('dashboard/setFocus', previousBlockId, { root: true });
		} else if (nextBlockId) {
			store.dispatch('dashboard/setFocus', nextBlockId, { root: true });
		}
	},

	async breakTextBlock(store, data) {
		let blockId = data.blockId;
		let insertPosition = data.insertPosition || 'after';
		let focus = data.focus || false;
		let block = store.getters['block'](blockId);
		let parentBlock = store.getters['parentBlock'](block.parent);

		let oldParent = JSON.parse(JSON.stringify(parentBlock));

		let position = 0;
		let blocksArray = parentBlock.blocks;

		for (let i = 0; i < blocksArray.length; i++) {
			if (blocksArray[i] === block._id) {
				position = i;
				break;
			}
		}

		let user = store.rootGetters['user/user'];

		let newBlock = {
			owner: user._id,
			type: 'text',
			content: {
				html: ''
			},
			source: {},
			blocks: [],
			parent: parentBlock._id,
			root: false,
			archive: false
		};

		newBlock = blockSpec.createBlock(newBlock);

		let newPosition = position + 1;
		if (insertPosition === 'before') {
			newPosition = position;
		}

		let blockData = {
			blocksArray: [newBlock],
			position: newPosition,
			parentBlock: parentBlock
		};

		parentBlock.blocks.splice(position + 1, 0, newBlock._id);

		// Actions that mutate the state
		await store.dispatch('addBlock', newBlock);
		await store.dispatch('updateBlock', parentBlock);

		// Now we add them to the transactions
		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/addBlock',
					payload: newBlock
				},
				{
					name: 'block/updateBlock',
					payload: parentBlock
				}
			],
			{ root: true }
		);

		// And to the undo setup
		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/addBlock',
					payload: newBlock
				},
				{
					name: 'block/updateBlock',
					payload: oldParent
				}
			],
			{ root: true }
		);

		//let createdBlocks = await store.dispatch('createBlocks', blockData);
		if (focus) {
			store.dispatch('dashboard/setFocus', newBlock._id, {
				root: true
			});
		}
		return true;
	},

	async addTextBlockToParent(store, blockData) {
		let block = blockSpec.createBlock(blockData.block);

		let parentBlock = store.getters['parentBlock'](block.parent);

		let oldParent = JSON.parse(JSON.stringify(parentBlock));
		parentBlock.blocks.splice(blockData.position, 0, block._id);

		// Actions that mutate the state
		await store.dispatch('addBlock', block);
		await store.dispatch('updateBlock', parentBlock);

		store.dispatch(
			'transaction/add',
			[
				{
					name: 'block/addBlock',
					payload: block
				},
				{
					name: 'block/updateBlock',
					payload: parentBlock
				}
			],
			{ root: true }
		);

		store.dispatch(
			'undo/add',
			[
				{
					name: 'block/addBlock',
					payload: block
				},
				{
					name: 'block/updateBlock',
					payload: oldParent
				}
			],
			{ root: true }
		);

		return block;
	}
};
